var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtherShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4999 15C6.37455 14.9974 7.21612 14.6653 7.85689 14.07L14.1169 17.647C13.6833 19.3413 14.5594 21.0969 16.1739 21.7692C17.7883 22.4415 19.6516 21.8265 20.5486 20.3253C21.4457 18.824 21.1046 16.8918 19.7476 15.7885C18.3907 14.6852 16.4295 14.7455 15.1429 15.93L8.88289 12.353C8.94852 12.1021 8.98477 11.8443 8.9909 11.585L15.1419 8.07C16.3628 9.17994 18.1943 9.28285 19.5319 8.31668C20.8694 7.35051 21.3473 5.57944 20.6773 4.07159C20.0072 2.56374 18.3725 1.73141 16.759 2.07657C15.1455 2.42173 13.9944 3.85 13.9999 5.5C14.0035 5.78808 14.0428 6.0746 14.1169 6.353L8.4329 9.6C7.52239 8.19142 5.74062 7.62676 4.185 8.25381C2.62939 8.88086 1.73729 10.5233 2.05816 12.1696C2.37903 13.8158 3.82266 15.0031 5.4999 15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherShare);
export default __webpack_public_path__ + "static/media/other-share.fbea52b4.svg";
export { ForwardRef as ReactComponent };